import React from "react";

const TableSales = ({ salesData, totalSales }) => {
  return (
    <div style={{ width: "100%", maxWidth: "400px" }}>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ borderBottom: "1.5px solid #000000" }}>
            <th
              style={{
                textAlign: "left",
                padding: "10px 6px",
                fontFamily: "Karla",
                fontWeight: "500",
                fontSize: "18px",
                lineHeight: "22px",
                letterSpacing: "-0.41px",
              }}
            >
              Total Sales
            </th>
            <th
              style={{
                textAlign: "right",
                padding: "10px 6px",
                fontFamily: "Karla",
                fontWeight: "500",
                fontSize: "18px",
                lineHeight: "22px",
              }}
            >
              {totalSales}
            </th>
          </tr>
        </thead>

        <tbody>
          {salesData && salesData.length > 0 ? (
            salesData.map((item, index) => (
              <tr key={index} style={{borderBottom: index === salesData.length - 1 ? "none" : "0.5px solid #444444"}}>
                <td
                  style={{
                    padding: "10px 6px",
                    textAlign: "left",
                    fontFamily: "Karla",
                    fontWeight: "500",
                    fontSize: "18px",
                    lineHeight: "100%",
                  }}
                >
                  {item?.name}
                </td>
                <td
                  style={{
                    padding: "10px 6px",
                    textAlign: "right",
                    fontWeight: "400",
                    fontFamily: "Karla",
                    fontSize: "18px",
                    lineHeight: "100%",
                    whiteSpace: "nowrap"
                  }}
                >
                  {item?.sale} Pcs
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="2" style={{ textAlign: "center", padding: "12px", color: "#888" }}>
                No sales data available.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TableSales;
